import axios from 'axios';
//import dotenv from 'dotenv';


//export const baseURL1 =  process.env.APP_TITLE;
// export const baseURL =  process.env.API_URL;
function getBaseURL() {
    // DEBUG backend trên local , đặt = true;
    const local = true;
    const production = window.location.hostname != 'localhost' &&
        window.location.hostname != '127.0.0.1'; // bachkhoaso.org;
    console.log('host name ', window.location.hostname);
    if (production) {
        // Lấy giao thức (protocol) và tên miền (hostname)
        const protocol = window.location.protocol; // https:, http:
        const hostname = window.location.hostname; // bachkhoaso.org

        // Kết hợp giao thức và tên miền
        const fulllUrl = `${protocol}//${hostname}/prod`;
        return fulllUrl;
    } else { //DEV
        if (local) {
            return "http://localhost:7070/prod";
        } else {
            return "https://bachkhoaso.org/prod";
        }
    }
}
export function getProtocolAndDomain() {
    //lấy domain name hiện tại
    const hostname = window.location.hostname; // bachkhoaso.org
    const protocol = window.location.protocol; // https:, http:
    return `${protocol}//${hostname}`;
}
export function getWebsocketBaseURL() {
    // DEBUG backend trên local , đặt = true;
    const local = true;
    const production = window.location.hostname != 'localhost' &&
        window.location.hostname != '127.0.0.1'; // bachkhoaso.org;
    console.log('host name ', window.location.hostname);
    const protocol = window.location.protocol; // https:, http:
    const hostname = window.location.hostname; // bachkhoaso.org
    let url = ''
    if (production) {
        const fulllUrl = `wss://${hostname}/ws/`;
        url = fulllUrl;
    } else {
        url = 'ws://localhost:7070/ws/';
    }
    url += '?token=' + localStorage.getItem('access_token');
    return url
}

//PRODUCTION//
export const baseURL = getBaseURL();
// export const baseURL = "https://bachkhoaso.org/prod";
// export const baseURL = "https://lotoproapp.com/prod";
// const baseURL = "https://lotoproapp.com/prod";
//  const baseURL = "https://cnlot88.net/prod";
// DEV
// export const baseURL = "http://localhost:7070/prod";


const axiosClient = axios.create({
    baseURL: baseURL,
    timeout: 120000
});

export default axiosClient;